import { render, staticRenderFns } from "./NavigateBackButton.vue?vue&type=template&id=5d2c8df6&"
import script from "./NavigateBackButton.vue?vue&type=script&lang=ts&"
export * from "./NavigateBackButton.vue?vue&type=script&lang=ts&"
import style0 from "./NavigateBackButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports